export default __webpack_public_path__ + "static/media/Terms-and-Conditions-of-Independent-Director.44dbe3fc.pdf";